module.exports = __webpack_public_path__ + "static/media/artwork_21.f2bbcab1.jpg";